import { cn } from "@wags/ui/ui-utils";
import type { ReactNode } from "react";
import { useScrollDirection } from "@wags/tanstack-start/browser";
import { BOTTOM_NAV_SLIDE_TRANSITION } from "@/lib/ui/bottomNav";
import { useFooterShowing } from "@/lib/ui/footerShowing";

export function AnimatedBottomNav({
    show,
    hideOnScroll = false,
    children,
}: {
    show: boolean;
    hideOnScroll?: boolean;
    children: ReactNode;
}) {
    const scrollDirection = useScrollDirection();
    const footerShowing = useFooterShowing();
    const scrollHidden =
        hideOnScroll && (scrollDirection === "down" || footerShowing);
    const hidden = !show || scrollHidden;

    return (
        <div
            inert={hidden ? true : undefined}
            aria-hidden={hidden ? true : undefined}
            className={cn(
                "fixed inset-x-0 bottom-0 z-40 md:hidden",
                BOTTOM_NAV_SLIDE_TRANSITION,
                hidden && "translate-y-full",
            )}
        >
            {children}
        </div>
    );
}
